// import { GoogleMap, Marker } from '@react-google-maps/api';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';

import { ReactComponent as CloseIcon } from '../../assets/icons/close-circle.svg';
import { ReactComponent as DeleteIcon } from '../../assets/icons/delete-icon.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/edit.svg';
// import { ReactComponent as CCS1ICON } from '../../assets/icons/device-management/ccs1.svg';
// import { ReactComponent as CCS2Icon } from '../../assets/icons/device-management/ccs2.svg';
// import { ReactComponent as CHADEMOIcon } from '../../assets/icons/device-management/chademo.svg';
// import { ReactComponent as J1172ICON } from '../../assets/icons/device-management/j1172.svg';
// import { ReactComponent as NACSICON } from '../../assets/icons/device-management/nacs.svg';
// import { ReactComponent as Type2Icon } from '../../assets/icons/device-management/type2.svg';
// import { ReactComponent as LocationIcon } from '../../assets/icons/location-icon.svg';
import { ReactComponent as ExpandIcon } from '../../assets/icons/tables/expand-icon.svg';
// import { ReactComponent as NewTabIcon } from '../../assets/icons/tables/new-tab.svg';
// import { brandIcons, brandImage } from '../../config/branding';
import config from '../../config/config';
import { PortalType } from '../../config/enum';
import { useBranding } from '../../contexts/BrandingContext';
// import { useGoogleMaps } from '../../contexts/google-map-context/GoogleMapContent';
import { usePortal } from '../../contexts/PortalContext/PortalContext';
import {
  AvailableDevice,
  RequestDeviceInterFace,
} from '../../interface/device-management-partner.interface';
import AddFacilityAccount from '../../pages/account-management/components/add-facility-account';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setNotificationMessage } from '../../redux/slices/NotificationManagementSlice';
import { setNotificationDetails } from '../../redux/slices/NotificationSlice';
import { fetchAllStationsList } from '../../redux/slices/Partners/ApprovedStationManagementSlice';
import {
  fetchAllDevices,
  fetchChargePointModels,
  fetchChargePointVendors,
} from '../../redux/slices/Partners/DeviceManagementSlice';
import { updateSidePanelData } from '../../redux/slices/TableSidePanelSlice';
import { RootState } from '../../redux/store';
import ConvertUTCtoDateTime from '../../shared-functions/ConvertUTCtoDateTime';
import getFirstSubdomain from '../../shared-functions/DomainsplitFunction';
import { permissionCheck } from '../../shared-functions/JWTDocodeFunction';
import deviceApi from '../../utils/api/partner/device-partner';
import BatteryLoader from '../battery-loader/BatteryLoader';
import MyButton from '../button/Button';
import CustomInput from '../custom-input/CustomInput';
// import DisableSwitchWarning from '../disable-warning/DisableWarning';
import DeleteWarning from '../delete-warning/DeleteWarning';
import ModalBox from '../modal-box/ModalBox';
import RadioButton from '../radio-button/RadioButton';
import SelectField from '../select-field/SelectField';
import SuccessNotification from '../success-notification/SuccessNotification';
import TabToggle from '../tab-toggle/TabToggle';
import { TooltipIcon } from '../tooltip/TooltipIcon';

import ConnectorSidePanel from './ConnectorSidePanel';
import FacilityDetailsSidePanel from './FacilityDetailsSidePanel';
// eslint-disable-next-line import/no-cycle
import StationSidePanel from './StationSidePanel';

interface DeviceSidePanelProperties {
  fetchIdFrom: 'queryParams' | 'props';
  id?: string;
  currentData?: AvailableDevice;
  onEditModeChange?: (isEdit: boolean) => void;
  action?: string;
  isEditMode?: boolean;
  hideHeader?: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
  showCloseIcon?: boolean;
}

interface Connector {
  connectorId: number;
  isReservationEnabled?: boolean;
  status?: string;
  _id?: string;
  isAvailable?: boolean;
  connectorType: string[];
  connectorFormat?: string;
  connectorRating?: any;
  currentType?: string;
  maxCurrent?: string;
  maxVoltage?: string;
  unit?: string;
}

interface ChargingPointProperties {
  _id?: string;
  chargingStation?: string;
  chargingPointName?: string;
  chargingPointSn?: string;
  createdAt?: string;
  updatedAt?: string;
  maximumOutputPower?: string;
  maximumOutputPowerUnit?: string;
  isAvailable?: boolean;
  isDeviceOffline?: boolean;
  connectors: Connector[];
  chargePointModel: string;
  ocppurl: string;
  adhocUrl: string;
  chargePointVendor: string;
  chargingStationName?: string;
  latitude?: string;
  longitude?: string;
  address?: string;
  accountCustomId?: string;
  accountName?: string;
  desiredPowerOutput?: number;
  powerUnit?: string;
  modelSeries?: string;
  currentType?: string;
  chargeRate?: {
    unit?: string;
    value?: number;
  };
  firmwareVersion?: string;
  tariffId?: string;
  skuNumber?: string;
  installationType?: string;
  networkConnectivity?: string;
  plugAndCharge?: boolean | string;
}

interface ModalBoxDetail {
  title: string | null;
  header: boolean;
  content: JSX.Element | null;
  notificationModal: boolean;
}

interface InputInterface {
  label: string;
  value: string;
  description: string;
}

interface AddDeviceProperties {
  _id: string;
  accountCustomId: string;
  accountName: string;
}

type Option = {
  value: string | number;
  label: string;
};

/**
 * Device side panel
 * @param {any} properties - The properties
 * @returns {any} JSX.Element
 */
export default function DeviceSidePanel(properties: DeviceSidePanelProperties) {
  const { t } = useTranslation(['sidePanel', 'station', 'partnerDeviceManagement']);
  const { portalType } = usePortal();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    fetchIdFrom,
    id,
    onEditModeChange,
    action,
    isEditMode,
    onClose,
    onSuccess,
    showCloseIcon = true,
  } = properties;
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [accountNameList, setAccountNameList] = useState<InputInterface[]>([]);
  const [showFacilityPanel, setShowFacilityPanel] = useState(false);
  const [facilityEditMode, setFacilityEditMode] = useState<boolean>(false);
  const { currentFacilityTagsList } = useAppSelector(
    (state: RootState) => state.partnersFacilityTags,
  );
  const [modalBoxStatus, setModalBoxStatus] = useState<'open' | 'close'>('close');
  const [modalBoxDetail, setModalBoxDetail] = useState<ModalBoxDetail>({
    title: '',
    header: false,
    content: null,
    notificationModal: false,
  });
  const { page, limit, loading, chargePointVendors } = useAppSelector(
    (states: RootState) => states.partnersDevice,
  );
  const { partnerStations } = useAppSelector((state) => state.partnersApprovedStation);
  // const { isLoaded } = useGoogleMaps();
  const dispatch = useAppDispatch();
  const [searchParameters, setSearchParameters] = useSearchParams();
  const [isEdit, setIsEdit] = useState(false);
  // const mapReference = useRef<google.maps.Map | null>(null);

  const [deviceDetails, setDeviceDetails] = useState<ChargingPointProperties>({
    connectors: [],
    chargePointModel: '',
    chargePointVendor: '',
    ocppurl: ' ',
    adhocUrl: '',
  });

  const [editData, setEditData] = useState<any>({});
  const [formStatus, setFormStatus] = useState({
    buttonLoader: false,
  });

  const [overlaySidePanel, setOverlaySidePanel] = useState<'closed' | 'station' | 'facility'>(
    'closed',
  );

  const [activeTab, setActiveTab] = useState<string>('deviceDetails');

  const { brandData } = useBranding();
  const domain = getFirstSubdomain();
  const qrBaseUrl = domain && brandData?.qrCode ? brandData?.qrCode : config.qrCodeUrl;
  const qrValue = `${qrBaseUrl}?deviceId=${deviceDetails.chargingPointSn || ''}${domain ? `&domain=${domain}` : ''}`;

  /**
   * Function to fetch station details.
   * @param {string} stationId - The ID of the station to fetch details for.
   */
  const handleFetchStationDetails = React.useCallback(
    async (stationId: string) => {
      setIsLoader(true);
      try {
        const response = await deviceApi.getChargingPointById(stationId);
        setDeviceDetails(response?.data);
        dispatch(
          updateSidePanelData({
            type: 'deviceId',
            value: {
              id: response?.data?._id || response?.data?.id || '',
              ...response?.data,
            },
          }),
        );
      } catch (error: any) {
        dispatch(
          setNotificationDetails({
            type: 'error',
            notificationDetails: {
              statusCode: error?.response?.data?.code || 200,
              message: error?.response?.data?.message || t('somethingWentWrong'),
            },
          }),
        );
      } finally {
        setIsLoader(false);
      }
    },
    [dispatch],
  );

  // /**
  //  * Function to open station view dashboard in current page or a new tab
  //  * @param {any} newTab boolean
  //  */
  // const handleOpenStationView = (newTab: boolean) => {
  //   if (!deviceDetails?.chargingStation) return;

  //   const basePath = location.pathname.includes('charger-expanded')
  //     ? 'station-expanded'
  //     : 'station-management';
  //   const sourcePath =
  //     location.state?.source ||
  //     new URLSearchParams(location.search).get('source') ||
  //     location.pathname + location.search;

  //   const deviceSearchParameters = `?searchBy=${deviceDetails.chargingStationName || ''}&source=${sourcePath}`;
  //   const url = `/ev-admin/${basePath}/${deviceDetails.chargingStation}/station-dashboard${deviceSearchParameters}`;

  //   if (newTab) {
  //     window.open(url, '_blank');
  //   } else {
  //     navigate(
  //       {
  //         pathname: `/ev-admin/${basePath}/${deviceDetails.chargingStation}/station-dashboard`,
  //         search: deviceSearchParameters,
  //       },
  //       { state: { source: sourcePath } },
  //     );
  //   }
  // };

  /**
   * Function to open device view dashboard in current page or a new tab
   * @param {any} newTab boolean
   */
  const handleOpenDeviceView = (newTab: boolean) => {
    const deviceId = deviceDetails?._id;
    if (!deviceId) return;

    const basePath = location.pathname.includes('charger-expanded')
      ? 'charger-expanded'
      : 'charger-management';
    const sourcePath =
      location.state?.source ||
      new URLSearchParams(location.search).get('source') ||
      location.pathname + location.search;

    const deviceSearchParameters = `?searchBy=${deviceDetails.chargingPointName || ''}&source=${sourcePath}`;

    if (newTab) {
      window.open(
        `/ev-admin/${basePath}/${deviceId}/device-details${deviceSearchParameters}`,
        '_blank',
      );
    } else {
      navigate(
        {
          pathname: `/ev-admin/${basePath}/${deviceId}/device-details`,
          search: deviceSearchParameters,
        },
        { state: { source: sourcePath } },
      );
    }
  };

  /**
   * Handle the fetch data for Api call function
   * @param {any} data - request parameters
   */
  const fetchData = (data: RequestDeviceInterFace) => {
    const selectedFacility = currentFacilityTagsList.find((item) => item.isSelected);

    if (selectedFacility?._id && !loading) {
      dispatch(
        fetchAllDevices({
          ...data,
        }),
      );
    }
  };

  /**
   * Toggle edit mode
   */
  const toggleEditMode = () => {
    if (isEdit) {
      setIsEdit(false);
      setEditData({});
      onEditModeChange?.(false);
      const newParameters = new URLSearchParams(searchParameters);
      if (newParameters.has('action')) {
        newParameters.delete('action');
        setSearchParameters(newParameters);
      }
      return;
    }

    setEditData({
      chargingStation: deviceDetails.chargingStation || '',
      chargingPointName: deviceDetails.chargingPointName || '',
      chargingPointSn: deviceDetails.chargingPointSn || '',
      chargePointModel: deviceDetails.chargePointModel || '',
      chargePointVendor: deviceDetails.chargePointVendor || '',
      connectors: deviceDetails.connectors || [],
      maximumOutputPower: deviceDetails.maximumOutputPower || 0,
      maximumOutputPowerUnit: deviceDetails.maximumOutputPowerUnit || 'kW',
      // desiredPowerOutput: deviceDetails.desiredPowerOutput || 0,
      desiredPowerOutput: (deviceDetails?.chargeRate?.value || 0) / 1000,
      powerUnit: deviceDetails.chargeRate?.unit || 'W',
      modelSeries: deviceDetails?.modelSeries || '',
      currentType: deviceDetails.currentType || '',
      accountCustomId: deviceDetails.accountCustomId || '',
      skuNumber: deviceDetails.skuNumber || '',
      installationType: deviceDetails.installationType || '',
      networkConnectivity: deviceDetails.networkConnectivity || '',
      plugAndCharge:
        deviceDetails.plugAndCharge !== undefined ? String(deviceDetails.plugAndCharge) : '',
    });

    setIsEdit(true);
    onEditModeChange?.(true);

    // Fetch stations if not available
    if (!partnerStations || partnerStations.length === 0) {
      dispatch(fetchAllStationsList());
    }
  };

  /**
   * Handle Input Change
   * @param {any} name - The name
   * @param {any} value - The value
   */
  const handleInputChange = (name: string, value: string | number | any) => {
    setEditData((previous: any) => ({
      ...previous,
      [name]: value,
    }));
  };

  /**
   * Handle individual connector type changes.
   */
  // const handleConnectorTypeChange = (connectorId: number, selectedTypes: string[]) => {
  //   const updatedConnectors = editData.connectors.map((connector: Connector) =>
  //     connector.connectorId === connectorId
  //       ? { ...connector, connectorType: selectedTypes }
  //       : connector,
  //   );
  //   setEditData({
  //     ...editData,
  //     connectors: updatedConnectors,
  //   });
  // };

  /**
   * Function to submit the edited device details.
   * @returns {Promise<void>} A promise that resolves when the device details are submitted.
   */
  const handleSubmitDeviceDetails = async () => {
    setFormStatus({ buttonLoader: true });

    // Validate required fields
    if (PortalType.NETWORKS === portalType || PortalType.APP === portalType) {
      if (!editData.accountCustomId || editData.accountCustomId.length !== 20) {
        dispatch(
          setNotificationDetails({
            type: 'error',
            notificationDetails: {
              statusCode: 400,
              message: t('accountIdRequired'),
            },
          }),
        );
        setFormStatus({ buttonLoader: false });
        return;
      }
    }

    if (!editData.chargingStation) {
      dispatch(
        setNotificationDetails({
          type: 'error',
          notificationDetails: {
            statusCode: 400,
            message: t('stationNameRequired'),
          },
        }),
      );
      setFormStatus({ buttonLoader: false });
      return;
    }

    if (!editData.chargingPointName) {
      dispatch(
        setNotificationDetails({
          type: 'error',
          notificationDetails: {
            statusCode: 400,
            message: t('deviceNameRequired'),
          },
        }),
      );
      setFormStatus({ buttonLoader: false });
      return;
    }

    if (!editData.chargingPointSn) {
      dispatch(
        setNotificationDetails({
          type: 'error',
          notificationDetails: {
            statusCode: 400,
            message: t('deviceIdRequired'),
          },
        }),
      );
      setFormStatus({ buttonLoader: false });
      return;
    }

    // Construct payload - filter out fields that shouldn't be sent or validate
    const {
      desiredPowerOutput,
      powerUnit,
      modelSeries, // Remove this from Edit api
      connectors,
      accountCustomId, // Exclude this as backend says "not allowed"
      networkConnectivity,
      ...rest
    } = editData;

    let plugAndChargeValue: boolean | undefined;
    if (editData.plugAndCharge === 'true') {
      plugAndChargeValue = true;
    } else if (editData.plugAndCharge === 'false') {
      plugAndChargeValue = false;
    }

    let networkConnectivityValue: string[] = [];
    if (Array.isArray(networkConnectivity)) {
      networkConnectivityValue = networkConnectivity;
    } else if (typeof networkConnectivity === 'string' && networkConnectivity.trim() !== '') {
      networkConnectivityValue = networkConnectivity.split(',').map((item: string) => item.trim());
    }

    const payload: any = {
      ...rest,
      networkConnectivity: networkConnectivityValue,
      plugAndCharge: plugAndChargeValue,
      // connectors: connectors?.map((connector: Connector) => {
      //   let capacityKWValue = '0';
      //   let nameValue = '';
      //   let currentTypeValue = (
      //     connector.currentType ||
      //     editData.currentType ||
      //     deviceDetails.currentType ||
      //     'AC'
      //   ).toUpperCase();

      //   if (currentTypeValue !== 'AC' && currentTypeValue !== 'DC') {
      //     currentTypeValue = 'AC';
      //   }

      //   if (connector.connectorRating) {
      //     if (typeof connector.connectorRating === 'object') {
      //       const ratingObject = connector.connectorRating as any;
      //       capacityKWValue = String(ratingObject.capacityKW || '0');
      //       nameValue = ratingObject.name || '';
      //       if (ratingObject.currentType) {
      //         currentTypeValue = String(ratingObject.currentType).toUpperCase();
      //       }
      //     } else {
      //       capacityKWValue = String(connector.connectorRating);
      //     }
      //   }

      //   if (!nameValue || nameValue.trim() === '') {
      //     nameValue = `Connector ${capacityKWValue} ${connector.unit || 'kW'}`;
      //   }

      //   const ratingObject = {
      //     name: nameValue,
      //     currentType: currentTypeValue,
      //     capacityKW: capacityKWValue,
      //   };

      //   return {
      //     connectorId: connector.connectorId,
      //     connectorType: connector.connectorType,
      //     connectorFormat: connector.connectorFormat || 'cable',
      //     connectorRating: ratingObject,
      //     maxCurrent: connector.maxCurrent || '0',
      //     maxVoltage: connector.maxVoltage || '0',
      //     unit: connector.unit || 'KW',
      //   };
      // }),
      chargeRate: {
        unit: powerUnit,
        value: String(powerUnit === 'W' ? Number(desiredPowerOutput) * 1000 : desiredPowerOutput),
      },
    };

    if (!payload.currentType) {
      delete payload.currentType;
    }

    try {
      await deviceApi.editDevice(payload, deviceDetails._id || '');

      setFormStatus({ buttonLoader: false });
      setIsEdit(false);
      onEditModeChange?.(false);

      // Refresh details
      if (deviceDetails._id) {
        handleFetchStationDetails(deviceDetails._id);
      }

      setModalBoxStatus('open');
      setModalBoxDetail({
        title: '',
        header: false,
        content: (
          <SuccessNotification
            title={t('deviceUpdatedSuccess')} // Ensure you have this key or use a generic one
            description=""
            notificationCloseTimer={3000}
            onNotificationClose={() => {
              setModalBoxStatus('close');
              const newParameters = new URLSearchParams(searchParameters);
              newParameters.delete('deviceId');
              newParameters.delete('action');
              setSearchParameters(newParameters);
              if (onSuccess) {
                onSuccess();
              } else {
                fetchData({ page, limit });
              }
            }}
          />
        ),
        notificationModal: true,
      });
    } catch (error: any) {
      setFormStatus({ buttonLoader: false });
      dispatch(
        setNotificationDetails({
          type: 'error',
          notificationDetails: {
            statusCode: error?.response?.data?.code || 200,
            message: error?.response?.data?.message || t('somethingWentWrong'),
          },
        }),
      );
    }
  };

  // const validPosition = React.useMemo(() => {
  //   const lat = parseFloat(deviceDetails.latitude || '');
  //   const lng = parseFloat(deviceDetails.longitude || '');
  //   return !Number.isNaN(lat) && !Number.isNaN(lng) ? { lat, lng } : null;
  // }, [deviceDetails.latitude, deviceDetails.longitude]);

  /**
   * Function to handle showing the map in a modal popup
   * @param {any} url - The url
   */
  // const handleViewLocationAction = () => {
  //   if (!validPosition) return;
  //   setModalBoxStatus('open');
  //   setModalBoxDetail({
  //     title: t('deviceLocation', 'Device Location'),
  //     header: true,
  //     content: (
  //       <div className="location-modal-map-wrap">
  //         {isLoaded && (
  //           <GoogleMap
  //             mapContainerStyle={{ width: '100%', height: '100%' }}
  //             center={validPosition}
  //             zoom={15}
  //             onLoad={(map) => {
  //               mapReference.current = map;
  //             }}>
  //             <Marker
  //               position={validPosition}
  //               icon={{
  //                 url: brandIcons.stationLocator,
  //                 scaledSize: new window.google.maps.Size(44, 44),
  //               }}
  //             />
  //           </GoogleMap>
  //         )}
  //       </div>
  //     ),
  //     notificationModal: false,
  //   });
  // };

  /**
   * Function to handle copying the adhoc url to clipboard
   */
  const handleCopyAdhocUrl = (url: string) => {
    if (!url) return;
    navigator.clipboard
      .writeText(url)
      .then(() => {
        dispatch(
          setNotificationMessage({
            message: t('urlCopied', 'URL copied to clipboard!'),
            status: true,
            type: 'success',
            code: 200,
          }),
        );
      })
      .catch((error) => {
        console.error('Failed to copy text: ', error);
        dispatch(
          setNotificationMessage({
            message: t('copyFailed', 'Failed to copy URL'),
            status: true,
            type: 'error',
            code: 500,
          }),
        );
      });
  };

  /**
   * Calls the API to delete a device.
   * @param {any} deviceId - The ID of the device to delete.
   */
  const handleConfirmDeleteDevice = (deviceId: string) => {
    deviceApi
      .deleteDevice(deviceId)
      .then(() => {
        setModalBoxStatus('open');
        setModalBoxDetail({
          title: null,
          header: false,
          content: (
            <SuccessNotification
              title={t('deviceDeletedSuccess', 'Device deleted successfully!')}
              description=""
              notificationCloseTimer={3000}
              onNotificationClose={() => {
                setModalBoxStatus('close');
                onClose?.();
                fetchData({ page, limit });
              }}
            />
          ),
          notificationModal: true,
        });
      })
      .catch((error) => {
        dispatch(
          setNotificationDetails({
            type: 'error',
            notificationDetails: {
              statusCode: error?.response?.data?.code || 200,
              message: error?.response?.data?.message || t('somethingWentWrong'),
            },
          }),
        );
      });
  };

  /**
   * Triggers the delete confirmation warning modal.
   * @param {any} deviceId - The ID of the device.
   */
  const handleDeleteDeviceClick = (deviceId: string) => {
    setModalBoxStatus('open');
    setModalBoxDetail({
      title: '',
      header: false,
      content: (
        <DeleteWarning
          selectedRowId={deviceId}
          title={t('deleteConfirmTitle', 'Delete Confirmation')}
          description={t(
            'deleteConfirmDescription',
            'Are you sure you want to delete this device?',
          )}
          cancelButtonOnClick={() => setModalBoxStatus('close')}
          submitSvgIcon={<DeleteIcon />}
          submitButtonOnClick={(id_) => id_ && handleConfirmDeleteDevice(id_)}
        />
      ),
      notificationModal: true,
    });
  };

  const stationId = React.useMemo(() => {
    return fetchIdFrom === 'queryParams' ? searchParameters.get('deviceId') : id;
  }, [fetchIdFrom, searchParameters, id]);

  /**
   * Function to fetch charge point models by chargePointVendor
   */
  const fetchChargePointModel = () => {
    dispatch(fetchChargePointModels(editData?.chargePointVendor));
  };

  const [allStationsList, setAllStationsList] = useState<{ label: string; value: string }[]>([]);
  /**
   * station list Api
   */
  const handleStationList = async () => {
    if (!editData.accountCustomId) return;
    try {
      const response = await deviceApi.fetchChargingStationList(editData.accountCustomId);
      const mappedStations = (response.data || []).map((station: any) => ({
        label: station.name || '',
        value: station._id || station.id || '',
        description: station?.address || '',
      }));
      setAllStationsList(mappedStations);
    } catch (error: any) {
      dispatch(
        setNotificationDetails({
          type: 'error',
          notificationDetails: {
            statusCode: error?.response?.data?.code || 200,
            message: error?.response?.data?.message || t('somethingWentWrong'),
          },
        }),
      );
    }
  };

  /**
   * Fetch account name list API and set the account name list state with the response data.
   */
  const handleAccountNameList = async () => {
    try {
      const response = await deviceApi.fetchAccountNameList();
      setAccountNameList(
        response.data.map((account: AddDeviceProperties) => ({
          label: account?.accountName,
          value: account?.accountCustomId,
        })),
      );
    } catch (error: any) {
      dispatch(
        setNotificationMessage({
          message: error?.response?.data?.message || t('somethingWentWrong'),
          status: true,
          type: 'error',
          code: error?.response?.data?.code,
        }),
      );
    }
  };
  /**
   * Handling information icon click
   */
  const handleOpenAddPartner = () => {
    setModalBoxDetail({
      title: '',
      header: false,
      content: (
        <AddFacilityAccount
          closeModal={(message: any) => {
            setModalBoxStatus('close');
            if (message) {
              handleAccountNameList();
              dispatch(
                setNotificationMessage({
                  message,
                  status: true,
                  type: 'success',
                }),
              );
            }
          }}
          sidebarClosed={() => setModalBoxStatus('close')}
        />
      ),
      notificationModal: false,
    });
    setModalBoxStatus('open');
  };

  /**
   * Handling information icon click
   * @param {any} option - receiving options as a generic
   */
  const handleOpenFacilityInformation = (option: Option) => {
    navigate(`?accountCustomId=${option.value}`);
    setShowFacilityPanel(true);
  };

  /**
   * Handling information icon click
   * @param {any} option - receiving options as a generic
   */
  const handleOpenStationInformation = (option: Option) => {
    navigate(`?accountCustomId=${option.value}`);
    setShowFacilityPanel(true);
  };

  useEffect(() => {
    handleAccountNameList();
  }, []);

  useEffect(() => {
    if (!editData.accountCustomId || editData.accountCustomId.length !== 20) return;
    handleStationList();
  }, [editData.accountCustomId]);

  useEffect(() => {
    if (editData?.chargePointVendor) {
      fetchChargePointModel();
    }
  }, [editData?.chargePointVendor]);

  useEffect(() => {
    if (!stationId) return;
    setOverlaySidePanel('closed');
    setIsEdit(false);
    setEditData({});
    setDeviceDetails({
      connectors: [],
      chargePointModel: '',
      chargePointVendor: '',
      ocppurl: '',
      adhocUrl: '',
    });
    handleFetchStationDetails(stationId);

    // Fetch charge point vendors, if chargePointVendors list is empty
    if (!chargePointVendors.length) {
      dispatch(fetchChargePointVendors());
    }
  }, [stationId, handleFetchStationDetails]);

  useEffect(() => {
    const currentAction = action || searchParameters.get('action');
    const isEditActive = !!(isEditMode || currentAction === 'edit');

    setIsEdit(isEditActive);

    if (isEditActive) {
      if (
        deviceDetails?._id &&
        (deviceDetails?._id === stationId || deviceDetails?.chargingPointSn === stationId)
      ) {
        setEditData((previous: any) => {
          if (!previous || Object.keys(previous).length === 0) {
            if (!partnerStations || partnerStations.length === 0) {
              dispatch(fetchAllStationsList());
            }
            return {
              chargingStation: deviceDetails.chargingStation || '',
              chargingPointName: deviceDetails.chargingPointName || '',
              chargingPointSn: deviceDetails.chargingPointSn || '',
              chargePointModel: deviceDetails.chargePointModel || '',
              chargePointVendor: deviceDetails.chargePointVendor || '',
              connectors: deviceDetails.connectors || [],
              maximumOutputPower: deviceDetails.maximumOutputPower || 0,
              maximumOutputPowerUnit: deviceDetails.maximumOutputPowerUnit || 'kW',
              desiredPowerOutput: (deviceDetails?.chargeRate?.value || 0) / 1000,
              powerUnit: deviceDetails.chargeRate?.unit || 'W',
              modelSeries: deviceDetails?.modelSeries || '',
              currentType: deviceDetails.currentType || '',
              accountCustomId: deviceDetails.accountCustomId || '',
              skuNumber: deviceDetails.skuNumber || '',
              installationType: deviceDetails.installationType || '',
              networkConnectivity: deviceDetails.networkConnectivity || '',
              plugAndCharge:
                deviceDetails.plugAndCharge !== undefined
                  ? String(deviceDetails.plugAndCharge)
                  : '',
            };
          }
          return previous;
        });
      }
    } else {
      setEditData({});
    }
  }, [
    action,
    searchParameters,
    deviceDetails,
    stationId,
    partnerStations,
    dispatch,
    isEditMode,
    onEditModeChange,
  ]);

  if (isLoader) {
    return (
      <div className="loader-wrap">
        <div className="loader">
          <BatteryLoader />
        </div>
      </div>
    );
  }

  if (showFacilityPanel) {
    return (
      <FacilityDetailsSidePanel
        actionActive
        isEditMode={facilityEditMode}
        onEditModeChange={setFacilityEditMode}
        fetchIdFrom="queryParams"
        onBack={() => setShowFacilityPanel(false)}
      />
    );
  }

  return (
    <div className="device-wrap">
      <ModalBox
        open={modalBoxStatus === 'open'}
        title={modalBoxDetail.title}
        content={modalBoxDetail.content}
        closeModal={() => setModalBoxStatus('close')}
        modalBoxAnimation="modalAnimateToLeft"
        notification={modalBoxDetail.notificationModal}
        header={modalBoxDetail.header}
      />
      <div className="devic-side-panel">
        {fetchIdFrom === 'props' && (
          <div className="side-panel-header-component">
            <div className="side-panel-header-left-title-actions">
              <p className="side-panel-header-title">
                {isEdit ? t('editDevice', 'Edit Device') : t('deviceDetails', 'Device Details')}
              </p>
              <div className="side-panel-header-left-icons">
                {!isEdit && (
                  <>
                    {/* Expand Icon */}
                    <div className="button-wrap">
                      <span
                        role="presentation"
                        className="access-facility"
                        onClick={() => handleOpenDeviceView(true)}>
                        <ExpandIcon />
                      </span>
                      <div className="hover-label">{t('expandPages', 'Expand Pages')}</div>
                    </div>

                    {/* Edit Icon */}
                    {(permissionCheck('partnerChargingDevicesUpdate') ||
                      permissionCheck('cpoChargingPointUpdate')) && (
                      <div className="button-wrap">
                        <span
                          role="presentation"
                          className="access-facility"
                          onClick={toggleEditMode}>
                          <EditIcon className="icon" />
                        </span>
                        <div className="hover-label">{t('edit', 'Edit')}</div>
                      </div>
                    )}

                    {/* Delete Icon */}
                    {(permissionCheck('partnerChargingDevicesDelete') ||
                      permissionCheck('cpoChargingPointDelete')) && (
                      <div className="button-wrap">
                        <span
                          role="presentation"
                          className="access-facility"
                          onClick={() => handleDeleteDeviceClick(deviceDetails._id || '')}>
                          <DeleteIcon className="icon delete" />
                        </span>
                        <div className="hover-label">{t('delete', 'Delete')}</div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            {showCloseIcon && <CloseIcon className="icon close-btn" onClick={onClose} />}
          </div>
        )}
        <div className="device-details-body">
          {isEdit ? (
            <div className="device-side-panel-container">
              <div className="device-side-panel-details">
                <div className="device-side-panel-content ">
                  <div className="edit-device-form">
                    <div className="full-width-field">
                      <h4>{t('basicInfo')}</h4>
                    </div>

                    {/* Account ID */}
                    {(PortalType.NETWORKS === portalType || PortalType.APP === portalType) && (
                      <SelectField
                        name="accountCustomId"
                        inputLabel={t('accountName')}
                        placeholder={t('enterAccountName')}
                        options={accountNameList}
                        showInformationIcon
                        onInformationClick={(options) => handleOpenFacilityInformation(options)}
                        description={(option) => option.value}
                        selectedValue={editData.accountCustomId}
                        onChangeValue={handleInputChange}
                        error={!editData.accountCustomId}
                        errorMessage={t('accountNameRequired')}
                        valueRequired
                        enableSearch
                        emptyActionLabel={t('station:addAccount') || 'Add Partner'}
                        onEmptyActionClick={handleOpenAddPartner}
                      />
                    )}

                    {/* Station Name */}
                    <SelectField
                      inputLabel={t('stationName')}
                      name="chargingStation"
                      placeholder={t('selectStation')}
                      options={
                        PortalType.NETWORKS === portalType || PortalType.APP === portalType
                          ? allStationsList
                          : partnerStations
                      }
                      showInformationIcon
                      onInformationClick={(options) => handleOpenStationInformation(options)}
                      description={(option) => option.description}
                      selectedValue={editData.chargingStation}
                      onChangeValue={handleInputChange}
                      error={!deviceDetails.chargingStation}
                      errorMessage={t('stationNameRequired')}
                      valueRequired
                      enableSearch
                    />

                    {/* Device Name */}
                    <CustomInput
                      inputLabel={t('deviceName')}
                      type="text"
                      name="chargingPointName"
                      placeholder={t('deviceName')}
                      value={editData.chargingPointName}
                      valueRequired
                      onChangeValue={handleInputChange}
                      error={!editData.chargingPointName}
                      errorMessage={t('deviceNameRequired')}
                    />

                    {/* Desired Power Output */}
                    <CustomInput
                      inputLabel={t('desiredPowerOutput')}
                      type="number"
                      placeholder={t('enterValue')}
                      valueRequired
                      name="desiredPowerOutput"
                      value={editData.desiredPowerOutput}
                      onChangeValue={handleInputChange}
                      decimalLimit={3}
                      maxValue={1000}
                    />

                    {/* Serial Number */}
                    <CustomInput
                      inputLabel={t('deviceId')}
                      type="text"
                      name="chargingPointSn"
                      placeholder={t('deviceId')}
                      value={editData.chargingPointSn}
                      tooltipText="This is not editable"
                      disabled
                    />
                  </div>

                  <div className="edit-device-form">
                    <div className="full-width-field">
                      <h4>{t('chargerInfo')}</h4>
                      <TooltipIcon text={t('chargerInfoTooltip')} />
                    </div>

                    {/* Maximum Power Output (disabled) */}
                    <CustomInput
                      inputLabel={t('maximumPowerOutput')}
                      type="number"
                      placeholder={t('enterValue')}
                      name="maximumOutputPower"
                      value={editData.maximumOutputPower}
                      onChangeValue={handleInputChange}
                      tooltipText="This field is automatically populated based on the Device ID."
                      disabled
                      decimalLimit={3}
                      maxValue={1000}
                    />

                    {/* Vendor (disabled) */}
                    <CustomInput
                      inputLabel={t('chargePointVendor')}
                      type="text"
                      placeholder={t('chargePointVendor')}
                      name="chargePointVendor"
                      value={editData.chargePointVendor}
                      onChangeValue={handleInputChange}
                      tooltipText="This field is automatically populated based on the Device ID."
                      disabled
                    />

                    {/* Device Model (disabled) */}
                    <CustomInput
                      inputLabel={t('chargePointModel')}
                      type="text"
                      placeholder={t('chargePointModel')}
                      name="chargePointModel"
                      value={editData.chargePointModel}
                      onChangeValue={handleInputChange}
                      tooltipText="This field is automatically populated based on the Device ID."
                      disabled
                    />

                    {/* SKU Number */}
                    <CustomInput
                      inputLabel={t('skuNumber', 'SKU Number')}
                      type="text"
                      placeholder={t('skuNumber', 'SKU Number')}
                      name="skuNumber"
                      value={editData.skuNumber || ''}
                      onChangeValue={handleInputChange}
                      tooltipText="This field is automatically populated based on the Device ID."
                      disabled
                    />

                    {/* Installation Type */}
                    <CustomInput
                      inputLabel={t('installationType', 'Installation Type')}
                      type="text"
                      placeholder={t('installationType', 'Installation Type')}
                      name="installationType"
                      value={editData.installationType || ''}
                      onChangeValue={handleInputChange}
                      tooltipText="This field is automatically populated based on the Device ID."
                      disabled
                    />

                    {/* Network Connectivity */}
                    <CustomInput
                      inputLabel={t('networkConnectivity', 'Network Connectivity')}
                      type="text"
                      placeholder={t('networkConnectivity', 'Network Connectivity')}
                      name="networkConnectivity"
                      value={editData.networkConnectivity || ''}
                      onChangeValue={handleInputChange}
                      tooltipText="This field is automatically populated based on the Device ID."
                      disabled
                    />

                    {/* Plug and Charge */}
                    <RadioButton
                      inputLabel={t('plugAndCharge', 'Plug and Charge')}
                      name="plugAndCharge"
                      value={editData.plugAndCharge}
                      onChangeValue={handleInputChange}
                      list={[
                        { label: 'Yes', value: 'true' },
                        { label: 'No', value: 'false' },
                      ]}
                      isDisabled
                    />

                    {/* Current Type (disabled) */}
                    <CustomInput
                      inputLabel={t('currentType')}
                      type="text"
                      placeholder={t('currentType')}
                      name="currentType"
                      value={editData.currentType || ''}
                      onChangeValue={handleInputChange}
                      tooltipText="This field is automatically populated based on the Device ID."
                      disabled
                    />

                    {/* Firmware Version */}
                    <CustomInput
                      inputLabel={t('firmwareVersion')}
                      type="text"
                      placeholder={t('firmwareVersion')}
                      name="firmwareVersion"
                      value={editData.firmwareVersion || ''}
                      onChangeValue={handleInputChange}
                      tooltipText="This field is automatically populated based on the Device ID."
                      disabled
                    />
                  </div>

                  <div>
                    <ConnectorSidePanel
                      fetchIdFrom="props"
                      id={deviceDetails._id}
                      connectors={editData.connectors}
                      currentType={editData.currentType}
                      showHeader={false}
                      chargingPointSn={deviceDetails.chargingPointSn}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="device-side-panel-container read-mode-stacked">
              <div className="tab-toggle-container">
                <TabToggle
                  tabs={[
                    { label: t('deviceDetails', 'Device Details'), value: 'deviceDetails' },
                    {
                      label: t('connectorDetails', 'Connector Details'),
                      value: 'connectorDetails',
                    },
                  ]}
                  defaultTab="deviceDetails"
                  onChange={(value) => setActiveTab(value)}
                  isLabelValue
                />
                <div className="tab-actions">
                  <MyButton
                    label={t('accessDevice', 'Access Device')}
                    buttonType="submit"
                    onClickFunc={() => handleOpenDeviceView(true)}
                  />
                </div>
              </div>

              {/* Section 2: Device Details */}
              {activeTab === 'deviceDetails' && (
                <div className="panel-section device-detail-sec">
                  {/* {!hideHeader && (
                    <div className="section-header-row">
                      <div className="section-header-actions">
                        <div className="info-group buttons-group">
                          <MyButton
                            label={t('accessDevice', 'Access Device')}
                            buttonType="submit"
                            onClickFunc={() => handleOpenDeviceView(true)}
                          />
                        </div>
                      </div>
                    </div>
                  )} */}

                  <div className="device-info-fields">
                    <div className="info-group">
                      <span className="info-label">{t('status', 'Status')}</span>
                      <div
                        className={`device-status-text-container ${deviceDetails.isDeviceOffline ? 'offline' : 'online'}`}>
                        <div className="icon" />
                        <p>{deviceDetails.isDeviceOffline ? t('offline') : t('online')}</p>
                      </div>
                    </div>
                    <div className="info-group">
                      <span className="info-label">{t('deviceName')}</span>
                      <p className="info-value">{deviceDetails.chargingPointName || '-'}</p>
                    </div>
                    <div className="info-group">
                      <span className="info-label">{t('stationName')}</span>
                      <p
                        role="presentation"
                        onClick={() => setOverlaySidePanel('station')}
                        className="info-value hyperlink">
                        {deviceDetails.chargingStationName || '-'}
                      </p>
                    </div>
                    <div className="info-group">
                      <span className="info-label">{t('serialNumber')}</span>
                      <p className="info-value">{deviceDetails.chargingPointSn || '-'}</p>
                    </div>
                    <div className="info-group">
                      <span className="info-label">{t('vendor')}</span>
                      <p className="info-value">{deviceDetails.chargePointVendor || '-'}</p>
                    </div>
                    <div className="info-group">
                      <span className="info-label">{t('firmwareVersion')}</span>
                      <p className="info-value">{deviceDetails.firmwareVersion || '-'}</p>
                    </div>
                    <div className="info-group">
                      <span className="info-label">{t('deviceId')}</span>
                      <p className="info-value">{deviceDetails.chargingPointSn || '-'}</p>
                    </div>
                    <div className="info-group">
                      <span className="info-label">{t('deviceModel')}</span>
                      <p className="info-value">{deviceDetails.chargePointModel || '-'}</p>
                    </div>
                    <div className="info-group">
                      <span className="info-label">{t('ocppId')}</span>
                      <p className="info-value">{deviceDetails.chargingPointSn || '-'}</p>
                    </div>
                    <div className="info-group">
                      <span className="info-label">{t('Device Brand')}</span>
                      <p className="info-value">{deviceDetails.chargePointVendor || '-'}</p>
                    </div>
                    <div className="info-group full-width">
                      <span className="info-label">{t('ocppurl')}</span>
                      <p className="info-value break-all">{deviceDetails.ocppurl || '-'}</p>
                    </div>
                    {qrValue === 'likeone-ti13-3' && (
                      <div className="info-group full-width">
                        <span className="info-label">{t('adhocurl')}</span>
                        {qrValue ? (
                          <p
                            role="presentation"
                            className="info-value hyperlink break-all"
                            onClick={() => handleCopyAdhocUrl(qrValue)}>
                            {qrValue}
                          </p>
                        ) : (
                          <p className="info-value">-</p>
                        )}
                      </div>
                    )}
                    <div className="info-group">
                      <span className="info-label">{t('created')}</span>
                      <p className="info-value">
                        {deviceDetails.createdAt
                          ? ConvertUTCtoDateTime(deviceDetails.createdAt)
                          : '-'}
                      </p>
                    </div>
                    <div className="info-group">
                      <span className="info-label">{t('lastUpdated')}</span>
                      <p className="info-value">
                        {deviceDetails.updatedAt
                          ? ConvertUTCtoDateTime(deviceDetails.updatedAt)
                          : '-'}
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {/* Section 3: Connector Details */}
              {activeTab === 'connectorDetails' && (
                <div className="panel-section connector-detail-sec">
                  <ConnectorSidePanel
                    fetchIdFrom="props"
                    id={deviceDetails._id}
                    connectors={deviceDetails.connectors}
                    currentType={deviceDetails.currentType}
                    showHeader={false}
                    chargingPointSn={deviceDetails.chargingPointSn}
                  />
                </div>
              )}
            </div>
          )}
        </div>

        <div className="device-details-footer">
          {isEdit && (
            <div className="footer-actions-edit">
              <MyButton
                label={t('cancel', 'Cancel')}
                onClickFunc={toggleEditMode}
                buttonType="outline"
              />
              <MyButton
                label={t('submit', 'Submit')}
                onClickFunc={handleSubmitDeviceDetails}
                buttonType="submit"
                loading={formStatus.buttonLoader}
                disableButton={formStatus.buttonLoader}
              />
            </div>
          )}
        </div>

        <div className="device-side-panel-description" />
        <div
          className={`device-panel-station-view-wrap ${overlaySidePanel === 'station' || overlaySidePanel === 'facility' ? 'active' : ''}`}
          onClick={(event) => event.stopPropagation()}
          role="presentation">
          {overlaySidePanel === 'station' ? (
            <div className="side-panel-content">
              <StationSidePanel
                fetchIdFrom="props"
                id={deviceDetails.chargingStation}
                onClose={() => setOverlaySidePanel('closed')}
              />
            </div>
          ) : (
            <div className="side-panel-content">
              {/* <FacilitySidePanel fetchIdFrom="props" id={deviceDetails.accountCustomId} /> */}
              <div />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
